import { IStoryData, StoryType } from 'interfaces/Story.interface';

const user0 = require('assets/user0.png');
const user1 = require('assets/user1.png');

const storiesData: IStoryData[] = [
  {
    id: '1',
    image: user0,
    username: 'allison',
    stories: [
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
        watched: false,
        url: '',
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
        watched: false,
        url: '',
      },
      {
        type: StoryType.Image,
        src: 'https://media.gettyimages.com/photos/quaideazam-picture-id184944186?s=612x612',
        watched: false,
        url: '',
      },
      {
        type: StoryType.Image,
        src: 'https://thumbor.forbes.com/thumbor/fit-in/x/https://www.forbes.com/advisor/in/wp-content/uploads/2022/03/monkey-g412399084_1280.jpg',
        watched: false,
        url: '/nft-details',
      },
    ],
  },
  {
    id: '2',
    image: user1,
    username: 'allison',
    stories: [
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
        watched: false,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
        watched: false,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
        watched: false,
      },
      {
        type: StoryType.Image,
        src: 'https://media.gettyimages.com/photos/quaideazam-picture-id184944186?s=612x612',
        watched: false,
      },
    ],
  },
  {
    id: '3',
    image: user0,
    username: 'allison',
    stories: [
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
        watched: false,
      },
      {
        type: StoryType.Image,
        src: 'https://media.gettyimages.com/photos/quaideazam-picture-id184944186?s=612x612',
        watched: false,
      },
      {
        type: StoryType.Image,
        src: 'https://media.gettyimages.com/photos/quaideazam-picture-id184944186?s=612x612',
        watched: true,
      },
    ],
  },
  {
    id: '4',
    image: user1,
    username: 'allison',
    stories: [
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
        watched: true,
      },
    ],
  },
  {
    id: '5',
    image: user1,
    username: 'alex',
    stories: [
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
        watched: true,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
        watched: true,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
        watched: true,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
        watched: true,
      },
      {
        type: StoryType.Video,
        src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
        watched: true,
      },
    ],
  },
];

export default storiesData;
